import React from 'react';
import PropTypes from 'prop-types';

import { indexToLetter } from 'helpers/sharedJsHelpers';

import WYSIWYG from 'components/WYSIWYG';

const LegacyAnswers = ({
  answers,
  selectedAnswerIds = [],
  correctAnswerIds,
  showResponseCorrectness = false,
  onSelectAnswer = () => {},
  multipleChoice = false,
  strikeThroughs = new Map(),
  disableAnswerSelection
}) => {
  const liBuilder = (answer, index) => {
    const isChecked = selectedAnswerIds.indexOf(answer.id) !== -1;
    const isCorrect = correctAnswerIds.indexOf(answer.id) !== -1;
    const hasStrikeThrough = strikeThroughs.size > 0 && strikeThroughs.has(answer.id)
                            && !strikeThroughs[answer.id].deleted;
    let status = null;
    if (showResponseCorrectness) {
      if (isCorrect) {
        status = true;
      } else if (isChecked) {
        status = false;
      }
    }

    let className = 'answer col col-12 col-xs-12';
    if (isCorrect && showResponseCorrectness) {
      className += ' correct-answer';
    }
    return (
      <li className={className} key={answer.choice}>
        <label
          className={`answer-label ${hasStrikeThrough && 'strikeThrough'}`}
          htmlFor={`answer-${answer.choice}`}
        >
          { status === true && (
            <div className="answer-status success">&#10004;&#xFE0E;</div>
          )}
          { status === false && (
            <div className="answer-status error">&#215;</div>
          )}
          <input
            readOnly={hasStrikeThrough}
            disabled={hasStrikeThrough || disableAnswerSelection}
            id={`answer-${answer.choice}`}
            className="response-input"
            type={multipleChoice ? 'checkbox' : 'radio'}
            value={answer.id}
            checked={isChecked}
            onChange={() => onSelectAnswer(answer.id)}
          />
          <span
            className="answer-letter-and-text"
          >
            <span className="answer-index">{ indexToLetter(index) }. </span>
            <WYSIWYG className="answer-name">{ answer.safe_name }</WYSIWYG>
          </span>
        </label>
      </li>
    );
  };

  return (
    <ul className="LegacyAnswers row">
      {answers.map((answer, index) => liBuilder(answer, index))}
    </ul>
  );
};

LegacyAnswers.propTypes = {
  answers: PropTypes.object.isRequired,
  correctAnswerIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectedAnswerIds: PropTypes.arrayOf(PropTypes.number),
  onSelectAnswer: PropTypes.func,
  showResponseCorrectness: PropTypes.bool,
  multipleChoice: PropTypes.bool,
  strikeThroughs: PropTypes.object,
  disableAnswerSelection: PropTypes.bool
};

export default LegacyAnswers;
